import { useEffect } from "react";
import { connect } from "react-redux";
import {
  getCurrentIdentityGroups,
  getCurrentIdentityGroupsRecursively,
  getIdentity,
  getCurrentIdentityAccounts,
  getMyGroups,
  getRequestsToApprove,
  getMyRequests,
  getGroupScopes,
} from "../actions/api";

const AppInitializer = ({
  getIdentity,
  getCurrentIdentityAccounts,
  getCurrentIdentityGroups,
  getCurrentIdentityGroupsRecursively,
  getMyGroups,
  getRequestsToApprove,
  getMyRequests,
  getGroupScopes,
}) => {
  useEffect(() => {
    getIdentity();
    getCurrentIdentityAccounts();
    getCurrentIdentityGroups();
    getGroupScopes();
    getMyGroups();
    getMyRequests();
    getRequestsToApprove();
    getCurrentIdentityGroupsRecursively();
  }, [
    getIdentity,
    getCurrentIdentityAccounts,
    getCurrentIdentityGroups,
    getGroupScopes,
    getMyGroups,
    getMyRequests,
    getRequestsToApprove,
    getCurrentIdentityGroupsRecursively,
  ]);

  return null;
};

export default connect(null, {
  getCurrentIdentityGroups,
  getCurrentIdentityGroupsRecursively,
  getIdentity,
  getCurrentIdentityAccounts,
  getMyGroups,
  getRequestsToApprove,
  getMyRequests,
  getGroupScopes,
})(AppInitializer);
